import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "./../_helpers";

// create slice

const name = "order";
let enumOrderStatus = {
  OrderCreated: 1,
  OrderAssigned: 2,
  OrderPrepared: 3,
  InvoiceSent: 4,
  PaymentReceived: 5,
  ReadyToDispatch: 6,
  OrderDispatched: 7,
  Cancelled: 8,
  Refund: 9,
};

const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = (builder) => {
  createExtraReducers(builder);
};
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const orderActions = { ...slice.actions, ...extraActions };
export const orderReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    order: {},
    orderList: [],
    error: null,
    orderSaveResponse: [],
    orderResponse: [],
    deleteCategoryResponse: [],
    orderDetail: [],
    deleteOrderResponse: [],
    userDrpList: [],
    prepperDrpList: [],
    dispatcherDrpList: [],
    enumOrderStatus: enumOrderStatus,
    orderAssignResponse: [],
    orderStatusHistoryUniqueList: [],
    orderPaymentTransactionResponse: [],
    dispatchDetailsResponse: [],
    orderPreparationResponse: [],
    orderProductDrpList: [],
    orderProductBoxDetails: [],
    skidBreakdownDetails: [],
    orderCancelResponse: [],
    isLoading: false,
    orderCourierResponse: [],
    orderCourierDetails: [],
    lotDetailList: [],
    orderReversedResponse: {},

    orderForSkidBarcode: [],
    skidBreakdownDetailsList: {},
    verifyAdminPasscodeResponse: {},
    packagesPerBoxResponse: {},
    auditTrailListReport: [],
  };
}
function createReducers() {
  return {
    clearOrderResponse,
    tempSetOrderWeightVerification,
  };

  function clearOrderResponse(state) {
    state.orderSaveResponse = [];
    state.orderResponse = [];
    state.deleteOrderResponse = [];
    state.orderDetail = [];
    state.orderAssignResponse = [];
    state.orderPaymentTransactionResponse = [];
    state.dispatchDetailsResponse = [];
    state.orderPreparationResponse = [];
    state.orderStatusHistoryUniqueList = [];
    state.orderCancelResponse = [];
    state.skidBreakdownDetails = [];
    state.orderCourierResponse = [];
    state.orderCourierDetails = [];
    state.lotDetailList = [];
  }

  function tempSetOrderWeightVerification(state, action) {
    state.orderDetail = action.payload && action.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/Order`;
  const paymentBaseUrl = `${process.env.REACT_APP_API_URL}/Payment`;
  const quickBookApiBaseUrl = `${process.env.REACT_APP_API_URL}/QuickBookApi`;

  return {
    saveOrder: saveOrder(),
    saveOrderAssign: saveOrderAssign(),
    savePaymentTransaction: savePaymentTransaction(),
    GetOrderList: GetOrderList(),
    GetOrderDetailsByID: GetOrderDetailsByID(),
    changeOrderStatus: changeOrderStatus(),
    orderCancel: orderCancel(),
    GetUserDrpList: GetUserDrpList(),
    GetOrderStatusHistoryUniqueByOrderID:
      GetOrderStatusHistoryUniqueByOrderID(),
    saveDispatchDetails: saveDispatchDetails(),
    saveOrderPreparation: saveOrderPreparation(),
    saveTemporaryOrderPreparation: saveTemporaryOrderPreparation(),
    GetOrderProductDrpList: GetOrderProductDrpList(),
    GetOrderProductBoxDetails: GetOrderProductBoxDetails(),
    GetSkidBreakdownDetails: GetSkidBreakdownDetails(),
    GetOrderSkidBreakDownID: GetOrderSkidBreakDownID(),
    GetOrdersForSkidBarcode: GetOrdersForSkidBarcode(),
    GetDispatchDetailID: GetDispatchDetailID(),
    AddCourierDetails: AddCourierDetails(),
    GetOrderCourierDetails: GetOrderCourierDetails(),
    revokeSkidBreakdown: revokeSkidBreakdown(),
    GetLotDetailsByOrderID: GetLotDetailsByOrderID(),
    updateOrderReversed: updateOrderReversed(),
    verifyAdminPasscode: verifyAdminPasscode(),
    updatePackagesPerBox: updatePackagesPerBox(),
    getAuditTrailReport: getAuditTrailReport(),
  };
  function GetOrderList() {
    return createAsyncThunk(
      `${name}/GetOrderList`,
      async (addFormData) =>
        await fetchWrapper.post(`${baseUrl}/GetOrderDetails`, addFormData)
    );
  }
  //get order detail by order ID
  function GetOrderDetailsByID() {
    return createAsyncThunk(
      `${name}/GetOrderDetailsByID`,
      async (Data) =>
        await fetchWrapper.get(
          `${baseUrl}/GetOrderDetailsByID?OrderID=${Data.OrderID}`
        )
    );
  }

  function saveOrder() {
    return createAsyncThunk(
      `${name}/saveOrder`,
      async (addFormData) =>
        await fetchWrapper.post(`${baseUrl}/InsertUpdateOrder`, addFormData)
    );
  }
  function changeOrderStatus() {
    return createAsyncThunk(
      `${name}/changeOrderStatus`,

      async (orderDetail) =>
        await fetchWrapper.post(`${baseUrl}/ChangeOrderStatus`, orderDetail)
    );
  }

  function orderCancel() {
    return createAsyncThunk(
      `${name}/orderCancel`,

      async ({
        OrderID,
        OrderNumber,
        ClientID,
        OrderStatusID,
        CancelledReason,
        CancelledBy,
        IsPartyDeco,
        CancelPasscode,
      }) =>
        await fetchWrapper.post(
          `${baseUrl}/OrderCancel?OrderID=${OrderID}&OrderStatusID=${OrderStatusID}&CancelledReason=${CancelledReason}&CancelledBy=${CancelledBy}&OrderNumber=${OrderNumber}&ClientID=${ClientID}&IsPartyDeco=${IsPartyDeco}&CancelPasscode=${CancelPasscode}`
        )
    );
  }
  function GetUserDrpList() {
    return createAsyncThunk(
      `${name}/GetUserDrpList`,

      async ({ UserTypeID1, UserTypeID2, Status }) =>
        await fetchWrapper.get(
          `${baseUrl}/getUserDrpList?UserTypeID1=${UserTypeID1}&UserTypeID2=${UserTypeID2}&Status=${Status}`
        )
    );
  }
  function saveOrderAssign() {
    return createAsyncThunk(
      `${name}/saveOrderAssign`,
      async ({
        OrderID,
        WareHouseID,
        AssignedPrepperID,
        AssignedDispatcherID,
        CreatedBy,
        OrderNumber,
        ClientID,
        IsPartyDeco,
      }) =>
        await fetchWrapper.get(
          `${baseUrl}/OrderAssign?OrderID=${OrderID}&WareHouseID=${WareHouseID}&AssignedPrepperID=${AssignedPrepperID}&AssignedDispatcherID=${AssignedDispatcherID}&CreatedBy=${CreatedBy}&OrderNumber=${OrderNumber}&ClientID=${ClientID}&IsPartyDeco=${IsPartyDeco}`
        )
    );
  }

  function GetOrderStatusHistoryUniqueByOrderID() {
    return createAsyncThunk(
      `${name}/GetOrderStatusHistoryUniqueByOrderID`,
      async (OrderID) =>
        await fetchWrapper.get(
          `${baseUrl}/GetOrderStatusHistoryUniqueByOrderID?OrderID=${OrderID}`
        )
    );
  }
  function savePaymentTransaction() {
    return createAsyncThunk(
      `${name}/savePaymentTransaction`,
      async (newAddPaymentData) =>
        await fetchWrapper.post(
          `${paymentBaseUrl}/InsertUpdatePayment`,
          newAddPaymentData
        )
    );
  }
  function saveDispatchDetails() {
    return createAsyncThunk(
      `${name}/saveDispatchDetails`,
      async (newAddDispatchDetails) =>
        await fetchWrapper.post(
          `${baseUrl}/UpdatetDispatchDetails`,
          newAddDispatchDetails
        )
    );
  }

  function saveOrderPreparation() {
    return createAsyncThunk(
      `${name}/saveOrderPreparation`,
      async (orderPreparation) =>
        await fetchWrapper.post(
          `${baseUrl}/SaveOrderPreparation`,
          orderPreparation
        )
    );
  }

  function saveTemporaryOrderPreparation() {
    return createAsyncThunk(
      `${name}/saveTemporaryOrderPreparation`,
      async (orderPreparation) =>
        await fetchWrapper.post(
          `${baseUrl}/SaveTemporaryOrderPreparation`,
          orderPreparation
        )
    );
  }

  function GetOrderProductDrpList() {
    return createAsyncThunk(
      `${name}/GetOrderProductDrpList`,
      async ({ OrderID }) =>
        await fetchWrapper.get(`${baseUrl}/GetOrderProduct?OrderID=${OrderID}`)
    );
  }
  function GetOrderProductBoxDetails() {
    return createAsyncThunk(
      `${name}/GetOrderProductBoxDetails`,
      async (OrderID) =>
        await fetchWrapper.get(
          `${baseUrl}/GetOrderProductBoxDetails?OrderID=${OrderID}`
        )
    );
  }
  function GetSkidBreakdownDetails() {
    return createAsyncThunk(
      `${name}/GetSkidBreakdownDetails`,
      async (skidBreakdownDate) =>
        await fetchWrapper.post(
          `${baseUrl}/GetSkidBreakdownDetails`,
          skidBreakdownDate
        )
    );
  }
  function GetOrderSkidBreakDownID() {
    return createAsyncThunk(
      `${name}/GetOrderSkidBreakDownID`,
      async (Data) =>
        await fetchWrapper.get(
          `${baseUrl}/GetOrderSkidBreakDownID?OrderID=${Data.OrderID}`
        )
    );
  }
  function GetDispatchDetailID() {
    return createAsyncThunk(
      `${name}/GetDispatchDetailID`,
      async (Data) =>
        await fetchWrapper.get(
          `${baseUrl}/GetDispatchDetailID?OrderID=${Data.OrderID}`
        )
    );
  }
  function GetOrdersForSkidBarcode() {
    return createAsyncThunk(
      `${name}/GetOrdersForSkidBarcode`,
      async (data) =>
        await fetchWrapper.get(`${baseUrl}/GetOrdersForSkidBarcode`, data)
    );
  }
  function AddCourierDetails() {
    return createAsyncThunk(
      `${name}/AddCourierDetails`,
      async (data) =>
        await fetchWrapper.post(`${baseUrl}/AddCourierDetails`, data)
    );
  }

  function GetOrderCourierDetails() {
    return createAsyncThunk(
      `${name}/GetOrderCourierDetails`,
      async (OrderID) =>
        await fetchWrapper.get(
          `${baseUrl}/GetOrderCourierDetails?OrderID=${OrderID}`
        )
    );
  }
  function revokeSkidBreakdown() {
    return createAsyncThunk(
      `${name}/revokeSkidBreakdown`,
      async (OrderID) =>
        await fetchWrapper.get(
          `${baseUrl}/RevokeSkidBreakdown?OrderID=${OrderID}`
        )
    );
  }

  function GetLotDetailsByOrderID() {
    return createAsyncThunk(
      `${name}/GetLotDetailsByOrderID`,
      async (Data) =>
        await fetchWrapper.get(
          `${baseUrl}/GetLotDetailsByOrderID?OrderID=${Data.OrderID}`
        )
    );
  }

  function updateOrderReversed() {
    return createAsyncThunk(
      `${name}/updateOrderReversed`,
      async (OrderModel) =>
        await fetchWrapper.post(
          `${quickBookApiBaseUrl}/UpdateOrderReversed`,
          OrderModel
        )
    );
  }

  function verifyAdminPasscode() {
    return createAsyncThunk(
      `${name}/verifyAdminPasscode`,
      async (Data) =>
        await fetchWrapper.get(
          `${baseUrl}/VerifyAdminPasscode?AdminPasscode=${Data.Passcode}`
        )
    );
  }
  function updatePackagesPerBox() {
    return createAsyncThunk(
      `${name}/updatePackagesPerBox`,
      async (OrderPerBoxCountData) =>
        await fetchWrapper.post(
          `${baseUrl}/UpdatePackagesPerBox`,
          OrderPerBoxCountData
        )
    );
  }
  function getAuditTrailReport() {
    return createAsyncThunk(
      `${name}/getAuditTrailReport`,
      async () => await fetchWrapper.get(`${baseUrl}/GetAuditTrailReport`)
    );
  }
}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.GetOrderList.pending, (state) => {
      state.isLoading = false;
      state.error = "";
    })
    .addCase(extraActions.GetOrderList.fulfilled, (state, action) => {
      state.isLoading = true;
      state.orderSaveResponse = [];
      state.orderResponse = [];
      state.orderPreparationResponse = [];
      state.orderList = action.payload;
    })
    .addCase(extraActions.GetOrderList.rejected, (state, action) => {
      state.isLoading = false; // Fix: should be false on failure
      state.error = action.error ? action.error.message : "An error occurred";
    })

    .addCase(extraActions.GetOrdersForSkidBarcode.pending, (state) => {
      state.loading = true;
    })
    .addCase(
      extraActions.GetOrdersForSkidBarcode.fulfilled,
      (state, action) => {
        state.orderForSkidBarcode = action.payload;
      }
    )
    .addCase(extraActions.GetOrdersForSkidBarcode.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    .addCase(extraActions.GetOrderDetailsByID.pending, (state) => {
      state.orderResponse = { loading: true };
    })
    .addCase(extraActions.GetOrderDetailsByID.fulfilled, (state, action) => {
      let lotDetailListData = [...state.lotDetailList];
      let orderDetailData = { ...action.payload };
      let WarrantyExpiryStatus = 0;
      let newFormData =
        lotDetailListData &&
        orderDetailData?.OrderProductModelList?.reduce((acc, item) => {
          // Apply condition to update WarrantyExpiryStatus
          if (item.LotNumber) {
            let rowLotDetail = lotDetailListData?.filter(
              (d) =>
                d.LotNumber.toLowerCase() ===
                  (item.LotNumber.trim() &&
                    item.LotNumber.trim().toLowerCase()) &&
                item.ProductID === d.ProductID
            );

            if (rowLotDetail?.[0]) {
              let lotVal = rowLotDetail?.[0];
              const currentDate = new Date();
              const expiredDate = new Date(lotVal.ExpiredDate);
              // Calculate the date 30 days before the expired date
              const thirtyDaysBefore = new Date(expiredDate);
              thirtyDaysBefore.setDate(expiredDate.getDate() - 30);
              // Set time components to zero to ignore time
              currentDate.setHours(0, 0, 0, 0);
              expiredDate.setHours(0, 0, 0, 0);
              thirtyDaysBefore.setHours(0, 0, 0, 0);

              if (currentDate > expiredDate) {
                WarrantyExpiryStatus = 1;
              } else if (currentDate >= thirtyDaysBefore) {
                WarrantyExpiryStatus = 2;
              } else {
                WarrantyExpiryStatus = 0;
              }
            } else {
              WarrantyExpiryStatus = 0;
            }
          }
          let updatedItem = {
            ...item,
            WarrantyExpiryStatus: WarrantyExpiryStatus,
          };
          // Push the updated item into the accumulator
          acc.push(updatedItem);
          return acc;
        }, []);
      orderDetailData.OrderProductModelList = newFormData;

      state.orderDetail = orderDetailData;
    })
    .addCase(extraActions.GetOrderDetailsByID.rejected, (state, action) => {
      state.orderResponse = { error: action.error };
    })
    .addCase(extraActions.saveOrder.pending, (state) => {
      state.orderSaveResponse = { loading: true };
    })
    .addCase(extraActions.saveOrder.fulfilled, (state, action) => {
      state.orderSaveResponse = action.payload;
    })
    .addCase(extraActions.saveOrder.rejected, (state, action) => {
      state.orderSaveResponse = { error: action.error };
    })
    .addCase(extraActions.changeOrderStatus.pending, (state) => {
      state.order = { loading: true };
    })
    .addCase(extraActions.changeOrderStatus.fulfilled, (state, action) => {
      state.orderResponse = action.payload;
      state.changeOrderStatus = action.payload;
    })
    .addCase(extraActions.changeOrderStatus.rejected, (state, action) => {
      state.error = { error: action.error };
    })
    .addCase(extraActions.orderCancel.pending, (state) => {
      state.orderCancelResponse = { loading: true };
    })
    .addCase(extraActions.orderCancel.fulfilled, (state, action) => {
      state.orderCancelResponse = action.payload;
    })
    .addCase(extraActions.orderCancel.rejected, (state, action) => {
      state.orderCancelResponse = { error: action.error };
    })
    .addCase(extraActions.GetUserDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetUserDrpList.fulfilled, (state, action) => {
      const dataList = action.payload;
      state.prepperDrpList =
        dataList && dataList.filter((d) => d.parentId === 3);
      state.dispatcherDrpList =
        dataList && dataList.filter((d) => d.parentId === 4);
    })
    .addCase(extraActions.GetUserDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })
    // Add the remaining cases similarly
    .addCase(extraActions.saveOrderAssign.pending, (state) => {
      state.orderAssignResponse = { loading: true };
    })
    .addCase(extraActions.saveOrderAssign.fulfilled, (state, action) => {
      state.orderAssignResponse = action.payload;
    })
    .addCase(extraActions.saveOrderAssign.rejected, (state, action) => {
      state.orderAssignResponse = { error: action.error };
    })
    .addCase(
      extraActions.GetOrderStatusHistoryUniqueByOrderID.pending,
      (state) => {
        state.isLoading = false;
        state.orderStatusHistoryUniqueList = { loading: true };
      }
    )
    .addCase(
      extraActions.GetOrderStatusHistoryUniqueByOrderID.fulfilled,
      (state, action) => {
        state.isLoading = true;
        state.orderStatusHistoryUniqueList = action.payload;
      }
    )
    .addCase(
      extraActions.GetOrderStatusHistoryUniqueByOrderID.rejected,
      (state, action) => {
        state.isLoading = true;
        state.orderStatusHistoryUniqueList = { error: action.error };
      }
    )
    .addCase(extraActions.savePaymentTransaction.pending, (state) => {
      state.orderPaymentTransactionResponse = { loading: true };
    })
    .addCase(extraActions.savePaymentTransaction.fulfilled, (state, action) => {
      state.orderPaymentTransactionResponse = action.payload;
    })
    .addCase(extraActions.savePaymentTransaction.rejected, (state, action) => {
      state.orderPaymentTransactionResponse = { error: action.error };
    })
    .addCase(extraActions.saveDispatchDetails.pending, (state) => {
      state.dispatchDetailsResponse = { loading: true };
    })
    .addCase(extraActions.saveDispatchDetails.fulfilled, (state, action) => {
      state.dispatchDetailsResponse = action.payload;
    })
    .addCase(extraActions.saveDispatchDetails.rejected, (state, action) => {
      state.dispatchDetailsResponse = { error: action.error };
    })
    .addCase(extraActions.saveOrderPreparation.pending, (state) => {
      state.orderPreparationResponse = { loading: true };
    })
    .addCase(extraActions.saveOrderPreparation.fulfilled, (state, action) => {
      state.orderPreparationResponse = action.payload;
    })
    .addCase(extraActions.saveOrderPreparation.rejected, (state, action) => {
      state.orderPreparationResponse = { error: action.error };
    })
    .addCase(extraActions.saveTemporaryOrderPreparation.pending, (state) => {
      state.orderPreparationResponse = { loading: true };
    })
    .addCase(
      extraActions.saveTemporaryOrderPreparation.fulfilled,
      (state, action) => {
        state.orderPreparationResponse = action.payload;
      }
    )
    .addCase(
      extraActions.saveTemporaryOrderPreparation.rejected,
      (state, action) => {
        state.orderPreparationResponse = { error: action.error };
      }
    )
    .addCase(extraActions.GetOrderProductDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetOrderProductDrpList.fulfilled, (state, action) => {
      state.orderProductDrpList = action.payload;
    })
    .addCase(extraActions.GetOrderProductDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })
    .addCase(extraActions.GetOrderProductBoxDetails.pending, (state) => {
      state.orderProductBoxDetails = { loading: true };
    })
    .addCase(
      extraActions.GetOrderProductBoxDetails.fulfilled,
      (state, action) => {
        state.orderProductBoxDetails = action.payload;
      }
    )
    .addCase(
      extraActions.GetOrderProductBoxDetails.rejected,
      (state, action) => {
        state.orderProductBoxDetails = { error: action.error };
      }
    )
    .addCase(extraActions.GetSkidBreakdownDetails.pending, (state) => {
      state.skidBreakdownDetails = { loading: true };
    })
    .addCase(
      extraActions.GetSkidBreakdownDetails.fulfilled,
      (state, action) => {
        state.skidBreakdownDetails = action.payload;
      }
    )
    .addCase(extraActions.GetSkidBreakdownDetails.rejected, (state, action) => {
      state.skidBreakdownDetails = { error: action.error };
    })
    .addCase(extraActions.GetOrderSkidBreakDownID.pending, (state) => {
      state.skidBreakdownDetailsList = { loading: true };
    })
    .addCase(
      extraActions.GetOrderSkidBreakDownID.fulfilled,
      (state, action) => {
        state.skidBreakdownDetailsList = action.payload;
      }
    )
    .addCase(extraActions.GetOrderSkidBreakDownID.rejected, (state, action) => {
      state.skidBreakdownDetailsList = { error: action.error };
    })
    .addCase(extraActions.GetDispatchDetailID.pending, (state) => {
      state.dispatchDetailsResponse = { loading: true };
    })
    .addCase(extraActions.GetDispatchDetailID.fulfilled, (state, action) => {
      state.dispatchDetailsList = action.payload;
    })
    .addCase(extraActions.GetDispatchDetailID.rejected, (state, action) => {
      state.dispatchDetailsList = { error: action.error };
    })
    .addCase(extraActions.AddCourierDetails.pending, (state) => {
      state.orderCourierResponse = { loading: true };
    })
    .addCase(extraActions.AddCourierDetails.fulfilled, (state, action) => {
      state.orderCourierResponse = action.payload;
    })
    .addCase(extraActions.AddCourierDetails.rejected, (state, action) => {
      state.orderCourierResponse = { error: action.error };
    })
    .addCase(extraActions.GetOrderCourierDetails.pending, (state) => {
      state.orderCourierDetails = { loading: true };
    })
    .addCase(extraActions.GetOrderCourierDetails.fulfilled, (state, action) => {
      state.orderCourierDetails = action.payload;
    })
    .addCase(extraActions.GetOrderCourierDetails.rejected, (state, action) => {
      state.orderCourierDetails = { error: action.error };
    })
    .addCase(extraActions.revokeSkidBreakdown.pending, (state) => {
      // Handle any specific loading state if needed
    })
    .addCase(extraActions.revokeSkidBreakdown.fulfilled, (state, action) => {
      // Handle successful response if needed
    })
    .addCase(extraActions.revokeSkidBreakdown.rejected, (state, action) => {
      // Handle error response if needed
    })
    .addCase(extraActions.GetLotDetailsByOrderID.pending, (state) => {
      // GetLotDetailsByOrderID
      state.lotDetailList = [];
    })
    .addCase(extraActions.GetLotDetailsByOrderID.fulfilled, (state, action) => {
      state.lotDetailList = action.payload;
    })
    .addCase(extraActions.GetLotDetailsByOrderID.rejected, (state, action) => {
      state.lotDetailList = [];
    })
    .addCase(extraActions.updateOrderReversed.pending, (state) => {
      //update Order Reversed
      state.orderReversedResponse = {};
    })
    .addCase(extraActions.updateOrderReversed.fulfilled, (state, action) => {
      state.orderReversedResponse = action.payload;
    })
    .addCase(extraActions.updateOrderReversed.rejected, (state, action) => {
      state.orderReversedResponse = { error: action.error };
    })
    .addCase(extraActions.verifyAdminPasscode.pending, (state) => {
      state.isLoading = false;
      state.verifyAdminPasscodeResponse = {};
    })
    .addCase(extraActions.verifyAdminPasscode.fulfilled, (state, action) => {
      state.isLoading = true;
      state.verifyAdminPasscodeResponse = action.payload;
    })
    .addCase(extraActions.verifyAdminPasscode.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error ? action.error.message : "An error occurred";
      state.verifyAdminPasscodeResponse = {};
    })
    //updatePackagesPerBox
    .addCase(extraActions.updatePackagesPerBox.pending, (state) => {
      state.isLoading = false;
      state.error = null;
    })
    .addCase(extraActions.updatePackagesPerBox.fulfilled, (state, action) => {
      state.isLoading = true;
      state.error = null;
      state.packagesPerBoxResponse = action.payload;
    })
    .addCase(extraActions.updatePackagesPerBox.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error ? action.error.message : "An error occurred";
    })
    .addCase(extraActions.getAuditTrailReport.pending, (state) => {
      state.isLoading = false;
      state.error = null;
      state.auditTrailListReport = [];
    })
    .addCase(extraActions.getAuditTrailReport.fulfilled, (state, action) => {
      state.isLoading = true;
      state.error = null;
      state.auditTrailListReport = action.payload;
    })
    .addCase(extraActions.getAuditTrailReport.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error ? action.error.message : "An error occurred";
      state.auditTrailListReport = [];
    });
}
